import store from '../../../index';

export default {
    namespaced: true,
    state: {
        mode: '',
        currentRaDom: {},
        indexComponent: -1,
        defaultRaDom: {
            contents: [
                {
                    url: '',
                    coordinate: ['0', '0', '0'],
                    scale: '100',
                    rotation: ['0', '0', '0'],
                    size: ['480', '640']
                }
            ],
            mode: '0'
        }
    },

    getters: {
        mode: (state) => state.mode,
        currentRaDomContent: (state) => state.currentRaDom.contents,
        defaultRaDom: (state) => state.defaultRaDom
    },

    mutations: {
        MODE_RESET_RA_DOM: (state) => {
            state.mode = '';
            state.indexComponent = -1;
        },
        ADD_CONTENT: (state) => {
            let defaultContent = state.defaultRaDom.contents[0];
            state.currentRaDom.contents.push(JSON.parse(JSON.stringify(defaultContent)));
        },
        RA_DOM_DELETE_COMPONENT: (state) => {
            state.currentRaDom.contents.splice(state.indexComponent, 1);
        },
        SET_DATA: (state, data) => {
            state.currentRaDom.contents[data.index] = Object.assign({}, state.currentRaDom.contents[data.index], data);
        },
        SET_DATA_COORDINATE: (state, data) => {
            state.currentRaDom.contents[data.index].coordinate[data.indexData] = data.value;
        },
        SET_DATA_ROTATION: (state, data) => {
            state.currentRaDom.contents[data.index].rotation[data.indexData] = data.value;
        },
        SET_DATA_SIZE: (state, data) => {
            state.currentRaDom.contents[data.index].size[data.indexData] = data.value;
        },
        SET_DATA_MODE: (state, data) => {
            state.currentRaDom.mode = data.mode;
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentRaDom = state.defaultRaDom;
        },
        RA_DOM_TRY_DELETE_COMPONENT: (state, index) => {
            state.mode = 'deleteComponent';
            state.indexComponent = index;
        }
    },

    actions: {
        modeResetRaDom: function (localStore) {
            localStore.commit('MODE_RESET_RA_DOM');
        },
        raDomUpdate: function (localStore) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentRaDom };
                store.dispatch('actions/updateActionData', value).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        addContent: function (localStore) {
            return new Promise(function (resolve) {
                localStore.commit('ADD_CONTENT');
                resolve();
            });
        },
        raDomTryDeleteComponent: function (localStore, index) {
            localStore.commit('RA_DOM_TRY_DELETE_COMPONENT', index);
        },
        raDomDeleteComponent: function (localStore) {
            localStore.commit('RA_DOM_DELETE_COMPONENT');
            localStore.commit('MODE_RESET_RA_DOM');
        }
    }
};
